import { render } from "./CouponData.vue?vue&type=template&id=b2de8a38&ts=true"
import script from "./CouponData.vue?vue&type=script&lang=ts"
export * from "./CouponData.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/psj7085139/sam/samva-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__